export default "__VITE_ASSET__80eebab3__"